import { IAtBy } from "interfaces/at-by";
import { IEchoFunction, EchoFunctionType } from "interfaces/echo-function";
import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";
import { AtByModel } from "../at-by-model";
import { TenantModel } from "../tenant/tenant-model";

export class ApiAuthenticatorFunctionModel implements IEchoFunction, GraphQLData {

  code: string = '';
  created: IAtBy = new AtByModel('', '');
  description: string = '';
  name: string = '';
  readme: string = '';
  lastModified: IAtBy = new AtByModel('', '');
  requirements: string[] = [];
  system: boolean = false;
  tenant: ITenant = new TenantModel();
  typeName: string = '';
  type: EchoFunctionType = EchoFunctionType.apiauthenticator;
  lastEvaluatedKey: string = '';

  public static create(
    code: string,
    created: IAtBy,
    description: string,
    name: string,
    readme: string,
    lastModified: IAtBy,
    requirements: string[],
    system: boolean,
    tenant: ITenant,
    typeName: string,
    type: EchoFunctionType) : ApiAuthenticatorFunctionModel {
    const t = new ApiAuthenticatorFunctionModel();
    t.code = code;
    t.created = created;
    t.description = description;
    t.name = name;
    t.readme = readme;
    t.lastModified = lastModified;
    t.requirements = requirements;
    t.system = system;
    t.tenant = tenant;
    t.typeName = typeName;
    t.type = type;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    console.log(data);
  }
}